const constants = {
  ZIP_LENGTH: 5,
};

export default constants;
